{
  "help": "עזרה",
  "info": "מידע"
}
